export default String.raw`
{% if usr.Authenticated -%}
<div>
    <div>{{translations.YouAreLoggedInAs}}: {{usr.Email}}</div>
    <div>
        {{translations.GoToClientProfile}}
        <a href='{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}' rel="noopener noreferrer nofollow" target="_blank">
            {{translations.CustomerProfile}}
        </a>
    </div>
</div>
{% elseif config.Registration.Disabled -%}
<div>
    {{translations.BlockedSignUpInfo}}
    <div>
        <a href='{{ page.BaseHref }}{{config.DefinedPages.Contact.Url}}' target="_blank" rel="noopener noreferrer">
            {{translations.Contact}}
        </a>
    </div>
</div>
    {% else -%}
        {% if config.CompanyOnly == false -%}
            {% if config.Registration.Retail.AddressVisible -%}
                {% assign retailTemplate = 'static-elements/register-with-address/register-with-address.html' -%}
            {% else -%}
                {% assign retailTemplate = 'static-elements/register-no-address/register-no-address.html' -%}
            {% endif -%}
            {% if config.Registration.Company.AddressVisible -%}
                {% assign companyTemplate = 'static-elements/register-with-address/register-with-address.html' -%}
            {% else -%}
                {% assign companyTemplate = 'static-elements/register-no-address/register-no-address.html' -%}
            {% endif -%}
<div class='registration-js'>
    <div class="reg-container__header remove-tab-title">
        <span>{{ translations.RegisterForm }}</span>
    </div>
    <div class="change-container remove-tab-title">
        <div class="change-container__type">
            <button class="change-type-js container-reload-js replace-template-js change-container__type text {% if include == 'retail' %} active {% endif %}" data-template="{{ retailTemplate }}" data-include="retail">{{ translations.PrivatePerson }}</button>
        </div>
        <div class="change-container__type">
            <button class="change-type-js container-reload-js replace-template-js change-container__type text {% if include == 'company' %} active {% endif %}" data-template="{{ companyTemplate }}" data-include="company">{{ translations.Company }}</button>
        </div>
        <div class="slider"></div>
    </div> 
        {% endif -%}
    <div class="form-js register-form-step-js with-database-check-js {% if settings.editDataFromGUS == 'yes' -%} allow-edit-gus-js {% endif -%} {% if settings.editDataFromNotRespondingGUS == 'yes' -%} allow-edit-when-gus-not-responding-js {% else -%} dont-allow-edit-when-gus-not-responding-js {% endif -%} {% if settings.editDataFromVIES == 'yes' -%} allow-edit-vies-js {% endif -%} allow-edit-when-vies-not-responding-js" data-template="partials/common/address-form-register-full.html">
        {% if include == 'company' -%}
            {% include 'partials/common/address-form-register-full.html' with 'company' -%}
        {% else -%}
            {% include 'partials/common/address-form-register-full.html' with 'retail' -%}
        {% endif -%}
    </div>
    {% endif -%}
</div>
`